module.exports = new __parcel__URL__("mineko-trust-certificates.ba29134c.png").toString();